import React, { useState } from "react";
import toast from "react-hot-toast";
import api from "../api";

const OPERATORS = [
  { name: "MVola (Telma)",  number: "034 27 536 24", color: "#e60000", bg: "#e6000015", icon: "🔴" },
  { name: "Orange Money",   number: "032 93 324 98", color: "#ff6600", bg: "#ff660015", icon: "🟠" },
];

export default function MobileMoneyModal({ interval, amountUSD, amountAriary, planLabel, onClose, onSuccess }) {
  const [step, setStep]         = useState("info");   // info | pending
  const [reference, setReference] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [copied, setCopied]     = useState(null);

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  };

  const handleRequest = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/mobilemoney/request", { interval });
      setReference(data.reference);
      setStep("pending");
    } catch (err) {
      toast.error(err.response?.data?.error || "Erreur");
    } finally { setLoading(false); }
  };

  const btn = (col, extra) => ({
    padding: "12px 20px", border: "none", borderRadius: 10,
    fontFamily: "Syne,sans-serif", fontWeight: 700, fontSize: 14,
    cursor: "pointer", background: col, color: "#fff", ...extra,
  });

  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000090", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 24, padding: 36, width: "100%", maxWidth: 480 }}>

        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: "50%", background: "linear-gradient(135deg,#e60000,#ff6600)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>📱</div>
            <div>
              <div style={{ fontFamily: "Syne,sans-serif", fontWeight: 800, fontSize: 16 }}>Mobile Money</div>
              <div style={{ fontSize: 13, color: "var(--text2)" }}>MVola · Orange Money</div>
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 22, color: "var(--text3)", cursor: "pointer" }}>×</button>
        </div>

        {step === "info" && (
          <>
            {/* Montant */}
            <div style={{ background: "var(--surface2)", borderRadius: 14, padding: 20, marginBottom: 20, textAlign: "center" }}>
              <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 4 }}>{planLabel}</div>
              <div style={{ fontFamily: "Syne,sans-serif", fontSize: 36, fontWeight: 800, color: "var(--accent)" }}>
                {amountAriary.toLocaleString("fr-FR")} Ar
              </div>
              <div style={{ fontSize: 13, color: "var(--text3)", marginTop: 4 }}>(≈ ${amountUSD})</div>
            </div>

            {/* Numéros */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text2)", marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.5 }}>Numéros de paiement</div>
              {OPERATORS.map(op => (
                <div key={op.name} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 16, background: op.bg, border: "1px solid " + op.color + "30", borderRadius: 12, marginBottom: 8 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ fontSize: 20 }}>{op.icon}</span>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14, color: op.color }}>{op.name}</div>
                      <div style={{ fontFamily: "monospace", fontSize: 18, fontWeight: 800, color: "var(--text)", letterSpacing: 1 }}>{op.number}</div>
                    </div>
                  </div>
                  <button onClick={() => copy(op.number.replace(/ /g, ""), op.name)}
                    style={{ padding: "6px 14px", background: copied === op.name ? "#6af7b8" : "var(--surface)", border: "1px solid var(--border)", borderRadius: 8, fontSize: 12, cursor: "pointer", color: copied === op.name ? "#0a2a1a" : "var(--text)", fontWeight: 600 }}>
                    {copied === op.name ? "✓ Copie" : "Copier"}
                  </button>
                </div>
              ))}
            </div>

            {/* Instructions */}
            <div style={{ background: "#7c6af720", border: "1px solid #7c6af740", borderRadius: 12, padding: 16, marginBottom: 24 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: "var(--accent)", marginBottom: 10 }}>📋 Instructions</div>
              {[
                "Cliquez Generer ma reference",
                "Envoyez le montant sur l un des numeros",
                "Indiquez la reference dans le motif du transfert",
                "Votre compte sera active sous 24h",
              ].map((s, i) => (
                <div key={i} style={{ display: "flex", gap: 10, marginBottom: 8, fontSize: 13, color: "var(--text2)" }}>
                  <span style={{ width: 22, height: 22, borderRadius: "50%", background: "var(--accent)", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{i + 1}</span>
                  {s}
                </div>
              ))}
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={onClose} style={{ ...btn("var(--surface2)", { color: "var(--text)", border: "1px solid var(--border)", flex: 1 }) }}>Annuler</button>
              <button onClick={handleRequest} disabled={loading}
                style={{ ...btn("linear-gradient(135deg,#e60000,#ff6600)", { flex: 2, opacity: loading ? 0.7 : 1 }) }}>
                {loading ? "Génération..." : "Générer ma référence"}
              </button>
            </div>
          </>
        )}

        {step === "pending" && (
          <>
            {/* Reference */}
            <div style={{ background: "var(--surface2)", borderRadius: 14, padding: 20, marginBottom: 20, textAlign: "center" }}>
              <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 8 }}>Votre référence de paiement</div>
              <div style={{ fontFamily: "monospace", fontSize: 22, fontWeight: 800, color: "var(--accent)", letterSpacing: 2, marginBottom: 12 }}>{reference}</div>
              <button onClick={() => copy(reference, "ref")}
                style={{ padding: "8px 20px", background: copied === "ref" ? "#6af7b8" : "var(--surface)", border: "1px solid var(--border)", borderRadius: 8, fontSize: 13, cursor: "pointer", color: copied === "ref" ? "#0a2a1a" : "var(--text)", fontWeight: 600 }}>
                {copied === "ref" ? "✓ Copié" : "📋 Copier la référence"}
              </button>
            </div>

            {/* Montant et numéros */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ textAlign: "center", fontFamily: "Syne,sans-serif", fontSize: 28, fontWeight: 800, color: "var(--accent3)", marginBottom: 16 }}>
                {amountAriary.toLocaleString("fr-FR")} Ar
              </div>
              {OPERATORS.map(op => (
                <div key={op.name} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", background: op.bg, border: "1px solid " + op.color + "30", borderRadius: 10, marginBottom: 8 }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: op.color }}>{op.icon} {op.name}</div>
                    <div style={{ fontFamily: "monospace", fontSize: 16, fontWeight: 800 }}>{op.number}</div>
                  </div>
                  <button onClick={() => copy(op.number.replace(/ /g, ""), op.name)}
                    style={{ padding: "5px 12px", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 8, fontSize: 12, cursor: "pointer", color: copied === op.name ? "var(--accent3)" : "var(--text)" }}>
                    {copied === op.name ? "✓" : "Copier"}
                  </button>
                </div>
              ))}
            </div>

            {/* Statut en attente */}
            <div style={{ background: "#f7c26a20", border: "1px solid #f7c26a40", borderRadius: 12, padding: 16, marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                <span style={{ fontSize: 20 }}>⏳</span>
                <span style={{ fontWeight: 700, color: "#c98000", fontSize: 14 }}>En attente de confirmation</span>
              </div>
              <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6 }}>
                Après votre transfert, l&apos;administrateur vérifiera votre paiement et activera votre compte Premium sous <strong>24h</strong>. Vous recevrez un email de confirmation.
              </div>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={onClose} style={{ ...btn("var(--surface2)", { color: "var(--text)", border: "1px solid var(--border)", flex: 1 }) }}>Fermer</button>
              <button onClick={onSuccess} style={{ ...btn("var(--accent)", { flex: 1 }) }}>Aller au dashboard</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}